import { Component, OnDestroy, OnInit } from '@angular/core';
import { DriverDistributionsService } from '../driver-distributions-services/driver-distributions-service.service';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';

@Component({
  selector: 'app-driver-distributions',
  templateUrl: './driver-distributions.component.html',
  styleUrls: ['./driver-distributions.component.css']
})
export class DriverDistributionsComponent implements OnInit, OnDestroy {
  distributionList = [];
  search: any;

  constructor(
    private driverDistributionsService: DriverDistributionsService
  ) { }

  ngOnInit() {
    this.getDistributionList();
  }

  getDistributionList() {
    this.driverDistributionsService
      .getDistributionList()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.distributionList = data;
        }
      });
  }

  ngOnDestroy(): void {
  }
}
